document.addEventListener("DOMContentLoaded", () => {
  const getUTMParameters = () => {
    const utm = JSON.parse(getCookie("UTMVAL"));
    
    document.querySelectorAll("#utm_source").forEach((e) => {e.value = utm.utmSource});
    document.querySelectorAll("#utm_medium").forEach((e) => {e.value = utm.utmMedium});
    document.querySelectorAll("#utm_campaign").forEach((e) => {e.value = utm.utmCampaign});
    document.querySelectorAll("#ad_group").forEach((e) => {e.value = utm.adGroup});
    document.querySelectorAll("#device").forEach((e) => {e.value = utm.device});
    document.querySelectorAll("#gad_source").forEach((e) => {e.value = utm.gadSource});
    document.querySelectorAll("#gclid").forEach((e) => {e.value = utm.gclid});
  };

  getUTMParameters();
});